
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {
components: {
XHeader,
Group,
Cell,
XButton,
Radio,
XInput,
Popup,
XSwitch,
Search
},
data() {
return {
memberId: '',
mtpx: 0,
pbList: [],

showPop: false,
renew: {
PbTypeId: 0,
pbTypeTitle: '',
pbOption: '',
pbAmount: '',
noticeUser: 'on'
},
results: [],
member: {info: {}},
pageLoaded: false,
}
},
computed: {
userLevel() {
let al = this.member.info.agent_level;
let isAgent = this.member.info.is_agent;
let ul = this.member.info.level;
if (isAgent > 0) {
return al === 3 ? '区县代' :
(al === 2 ? '代理' :
(al === 1 ? '省级代理' : ''));
} else {
return ul === 1 ? '普通用户' :
(ul === 2 ? '初级用户' :
(ul === 3 ? '中级用户' :
(ul === 4 ? '高级用户' : '')));
}
}
},
created: function () {
this.$vux.loading.show({'text': '加载中'});
document.title = '会员管理';
this.$http.get(this.tianYiWebUrl + '/wechat/admin/initDataForAdminMemberInfo',{params:{'uid':this.memberId}}).then(r => {
this.$vux.loading.hide();
let res = r.data;
if (res.code === 200) {
this.pbList = res.data.pbList;
}
})
},
filters: {
getTitle: function (v) {
switch (v) {
case 6:
return '护眼水';
case 7:
return '护肤水';
}
}
},
methods: {
setFocus() {
this.$refs.search.setFocus()
},
resultClick(item) {
window.alert('you click the result item: ' + JSON.stringify(item))
},
getResult(val) {
console.log('on-change', val)
this.results = val ? getResult(this.value) : []
},
onSubmit() {
this.$refs.search.setBlur()
this.$vux.toast.show({
type: 'text',
position: 'top',
text: 'on submit'
})
},
onFocus() {
console.log('on focus')
this.mtpx = 100;
},
onCancel() {
console.log('on cancel')
this.mtpx = 0;
},
getUserInfo() {
this.fetchUserInfo();
},
fetchUserInfo() {
document.title = this.memberId + '的个人信息';
this.$vux.loading.show({'text': '加载中'});
const url = this.tianYiWebUrl + '/wechat/uc/ajaxGetMemberInfo';
this.$http.get(url, {params: {uid: this.memberId}}).then(r => {
this.$vux.loading.hide();
let res = r.data;
if (res.code === 200) {
this.member = res.data;
this.pageLoaded = true;
}
if (res.code === 404) {
this.$vux.toast.show({
'type': 'cancel',
'text': '用户不存在'
})
}
});
},
changePromiseBalance() {
this.renew.pbAmount = +this.renew.pbAmount;
if (this.renew.pbAmount < 1) {
this.$vux.alert.show('金额必须大于1元');
this.renew.pbAmount = ''
} else if (['+', '-'].indexOf(this.renew.pbOption) === -1) {
this.$vux.alert.show('操作类型错误');
} else {
let that = this;
this.$vux.confirm.show({  // 组件除show外的属性
'title': '确认操作',
'content': '是否给' + that.memberId + '增加' + that.renew.pbAmount + '元' + that.renew.pbType + '库存',
onCancel() {
that.renew = {
PbTypeId: 0,
pbTypeTitle: '',
pbOption: '',
pbAmount: '',
noticeUser: 'on'
};
that.showPop = false;
that.$vux.toast.show({
'type': 'cancel',
'text': '操作取消'
})
},
onConfirm() {
that.$vux.loading.show('处理中');
that.$http.post(that.tianYiWebUrl + '/wechat/admin/renewAgent', {uid: that.memberId, ...that.renew}).then(r => {
that.$vux.loading.hide();
let res = r.data;
if (res.code === 200) {
that.pbList = res.data;
} else {
that.$vux.alert.show('操作失败');
}
})
}
});
}
},
getCateName: function (product_cate_id) {
return {6: '护眼水', 7: '护肤水'}[product_cate_id];
},
renewPb(obj) {
console.log(obj)
this.renew.pbType = this.getCateName(obj.product_cate_id);
this.renew.PbTypeId = obj.product_cate_id;
this.showPop = true;
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/AdminMemberInfo.vue